import { render, staticRenderFns } from "./ImportButton.vue?vue&type=template&id=0db7c956&scoped=true&lang=html&"
import script from "./ImportButton.vue?vue&type=script&lang=js&"
export * from "./ImportButton.vue?vue&type=script&lang=js&"
import style0 from "./ImportButton.vue?vue&type=style&index=0&id=0db7c956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db7c956",
  null
  
)

export default component.exports